import { gql } from '@apollo/client';

export const PRODUCT_CATEGORIES = gql`
  query GetProductCategories($contractorId: Int, $context: RequestContext!) {
    productCategories(contractorId: $contractorId, context: $context) {
      id
      name
      shortname
      additionalInfo {
        description
        image
        numBlackSlopes
        numBlueSlopes
        numGreenSlopes
        numKmSlope
        numRedSlopes
        numSkiLift
        numTotalSlopes
        shortDescription
      }
    }
  }
`;
